// import React, { useEffect, useState } from "react";
// import { useMessageApi } from "../../../provider/AntdNotification";
// // import TabsContain from "../../../views/components/reuseComp/TabsContain";
// import { useQueryState } from "nuqs";
// import HeaderSection from "./HeaderSection";
// import { Form } from "antd";
// import {
//   useHomeDataDetail,
//   useHomeDataSave,
// } from "../../../hooks/api/homepage/hooks";
// import { getSingleImageUrl } from "../../../lib/utils";
// import HomeBanner from "./HomeBanner";
// import FilingMilestone from "./FilingMilestone";
// import AboutUsSection from "../../../views/components/sections/AboutUsSection";
// import OurServicesSection from "./OurServicesSection";
// import WhyChooseTGC from "./WhyChooseTGC";
// import GlobalReach from "./GlobalReach";
// import DigitalBoucher from "./DigitalBoucher";
// import TrustedPartners from "./TrustedPartners";
// import Testimonials from "./Testimonials";
// import Footer from "./Footer";
// import TabsContain from "../../components/reuseComp/TabsContain";
// import QuickActions from "./QuickActions";
// import FilingProgress from "./FilingProgress";
// import TaxesSimplified from "./TaxesSimplified";
// import AboutSection from "./AboutSection";

// const HomeTabs: React.FC<{ setBreadcrumb: (value: string) => void }> = ({
//   setBreadcrumb,
// }) => {
//   const message = useMessageApi();
//   const [tab, setTab] = useQueryState("tab");
//   const [form] = Form.useForm();
//   const activeTab = tab || "Banner";
//   const [isEditing, setIsEditing] = useState(false);
//   const [pageData, setPageData] = useState<any>(null);

//   // ⭐ Review edit state
//   const [reviewMode, setReviewMode] = useState<"list" | "add" | "edit">("list");
//   const [editingReviewIndex, setEditingReviewIndex] = useState<number | null>(
//     null
//   );

//   const { data } = useHomeDataDetail();
//   const { mutate: updateHomeData, isPending } = useHomeDataSave({});

//   const handleChangeTab = (section: string) => {
//     setTab(section);
//     setIsEditing(false);
//     setBreadcrumb(section);
//     setReviewMode("list");
//     setEditingReviewIndex(null);
//   };

//   useEffect(() => {
//     if (data?.data) setPageData(data.data);
//   }, [data]);

//   const handleSave = async () => {
//     try {
//       const values = await form.validateFields();

//       let payload: any = {
//         _id: pageData?._id,
//         banner: pageData?.banner || {},
//         filingMilestones: pageData?.filingMilestones || {},
//         quickActions: pageData?.quickActions || {},
//         filingProgress: pageData?.filingProgress || {},
//         taxesSimplified: pageData?.taxesSimplified || {},
//         about: pageData?.about || {},
//       };

//       if (values.banner) {
//         payload.banner = {
//           ...values.banner,
//           image: getSingleImageUrl(values.banner?.image),
//         };
//       }

//       if (values.milestone) {
//         payload.filingMilestones = {
//           ...values.milestone,
//         };
//       }

//       if (values.quickActions) {
//         payload.quickActions = {
//           ...values.quickActions,
//         };
//       }

//       if (values.filingProgress) {
//         payload.filingProgress = {
//           ...values.filingProgress,
//         };
//       }

//       if (values.taxesSimplified) {
//         payload.taxesSimplified = {
//           ...values.taxesSimplified,
//           image: getSingleImageUrl(values.taxesSimplified?.image),
//         };
//       }

//       if (values.about) {
//         payload.about = {
//           ...values.about,
//         };
//       }

//       if (activeTab === "Testimonials") {
//         const items = [...(pageData?.testimonials?.items || [])];

//         if (reviewMode === "add") {
//           items.push(values.review);
//         }

//         if (reviewMode === "edit" && editingReviewIndex !== null) {
//           items[editingReviewIndex] = values.review;
//         }

//         payload.testimonials = {
//           heading:
//             values.testimonials?.heading ?? pageData?.testimonials?.heading,
//           subtext:
//             values.testimonials?.subtext ?? pageData?.testimonials?.subtext,
//           items,
//         };
//       }

//       if (values.footer) {
//         payload.footer = {
//           ...values.footer,
//         };
//       }

//       updateHomeData(payload, {
//         onSuccess: (res) => {
//           message.success("Home data updated successfully");
//           setPageData(res.data);
//           setIsEditing(false);
//           setReviewMode("list");
//           setEditingReviewIndex(null);
//         },
//         onError: () => message.error("Failed to update page"),
//       });
//     } catch (error) {
//       console.log("❌ Validation failed:", error);
//     }
//   };

//   const handleCancel = () => {
//     setIsEditing(false);
//     setReviewMode("list");
//     setEditingReviewIndex(null);
//   };

//   const sections = [
//     "Banner",
//     "Filing Milestones",
//     "Quick Actions",
//     "Filing Progress",
//     "Taxes Simplified",
//     "About",
//   ];

//   const handleReviewDelete = (index: number) => {
//     const updated = [...(pageData?.testimonials?.items || [])];
//     updated.splice(index, 1);

//     const payload = {
//       ...pageData,
//       testimonials: {
//         ...pageData?.testimonials,
//         items: updated,
//       },
//     };

//     console.log(payload, "delete-paylaod");

//     updateHomeData(payload, {
//       onSuccess: () => {
//         message.success("Review deleted successfully");
//         setPageData(payload);
//         setReviewMode("list");
//         setEditingReviewIndex(null);
//       },
//       onError: () => message.error("Failed to delete review"),
//     });
//   };

//   return (
//     <div>
//       <TabsContain
//         handleChangeTab={handleChangeTab}
//         sections={sections}
//         activeTab={activeTab}
//       />

//       {/* {activeTab === "Header" && (
//         <HeaderSection
//           handleCancel={handleCancel}
//           handleSave={handleSave}
//           headerData={pageData?.header || {}}
//           form={form}
//           isEditing={isEditing}
//           setIsEditing={setIsEditing}
//           loading={isPending}
//         />
//       )} */}

//       {activeTab === "Banner" && (
//         <HomeBanner
//           handleCancel={handleCancel}
//           handleSave={handleSave}
//           bannerData={pageData?.banner || {}}
//           form={form}
//           isEditing={isEditing}
//           setIsEditing={setIsEditing}
//           loading={isPending}
//         />
//       )}

//       {activeTab === "Filing Milestones" && (
//         <FilingMilestone
//           handleCancel={handleCancel}
//           handleSave={handleSave}
//           milestoneData={pageData?.filingMilestones || {}}
//           form={form}
//           isEditing={isEditing}
//           setIsEditing={setIsEditing}
//           loading={isPending}
//         />
//       )}

//       {activeTab === "Quick Actions" && (
//         <QuickActions
//           handleCancel={handleCancel}
//           handleSave={handleSave}
//           quickActionsData={pageData?.quickActions || {}}
//           form={form}
//           isEditing={isEditing}
//           setIsEditing={setIsEditing}
//           loading={isPending}
//         />
//       )}

//       {activeTab === "Filing Progress" && (
//         <FilingProgress
//           handleCancel={handleCancel}
//           handleSave={handleSave}
//           filingProgressData={pageData?.filingProgress || {}}
//           form={form}
//           isEditing={isEditing}
//           setIsEditing={setIsEditing}
//           loading={isPending}
//         />
//       )}

//       {activeTab === "Taxes Simplified" && (
//         <TaxesSimplified
//           handleCancel={handleCancel}
//           handleSave={handleSave}
//           taxesSimplifiedData={pageData?.taxesSimplified || {}}
//           form={form}
//           isEditing={isEditing}
//           setIsEditing={setIsEditing}
//           loading={isPending}
//         />
//       )}

//       {activeTab === "About" && (
//         <AboutSection
//           handleCancel={handleCancel}
//           handleSave={handleSave}
//           aboutData={pageData?.about || {}}
//           form={form}
//           isEditing={isEditing}
//           setIsEditing={setIsEditing}
//           loading={isPending}
//         />
//       )}

//       {activeTab === "About Us" && (
//         <AboutUsSection
//           isEditing={isEditing}
//           setIsEditing={setIsEditing}
//           handleCancel={handleCancel}
//           handleSave={handleSave}
//           form={form}
//           aboutUsData={pageData?.aboutus}
//           loading={isPending}
//         />
//       )}

//       {activeTab === "Our Services" && (
//         <OurServicesSection
//           isEditing={isEditing}
//           setIsEditing={setIsEditing}
//           handleCancel={handleCancel}
//           handleSave={handleSave}
//           form={form}
//           ourServiceData={pageData?.our_services}
//           loading={isPending}
//         />
//       )}

     

//       {activeTab === "Why Choose TGC" && (
//         <WhyChooseTGC
//           isEditing={isEditing}
//           setIsEditing={setIsEditing}
//           handleCancel={handleCancel}
//           handleSave={handleSave}
//           form={form}
//           whyChooseTGCData={pageData?.why_choose_tgc}
//           loading={isPending}
//         />
//       )}

//       {activeTab === "Global Reach" && (
//         <GlobalReach
//           isEditing={isEditing}
//           setIsEditing={setIsEditing}
//           handleCancel={handleCancel}
//           handleSave={handleSave}
//           form={form}
//           globalReachData={pageData?.global_reach}
//           loading={isPending}
//         />
//       )}

//       {activeTab === "Digital Boucher" && (
//         <DigitalBoucher
//           isEditing={isEditing}
//           setIsEditing={setIsEditing}
//           handleCancel={handleCancel}
//           handleSave={handleSave}
//           form={form}
//           digital_boucherData={pageData?.digital_boucher}
//           loading={isPending}
//         />
//       )}

//       {activeTab === "Trusted Partners" && (
//         <TrustedPartners
//           isEditing={isEditing}
//           setIsEditing={setIsEditing}
//           handleCancel={handleCancel}
//           handleSave={handleSave}
//           form={form}
//           trustedPartnersData={pageData?.trusted_partners}
//           loading={isPending}
//         />
//       )}

   

//       {activeTab === "Testimonials" && (
//         <Testimonials
//           isEditing={isEditing}
//           setIsEditing={setIsEditing}
//           handleCancel={handleCancel}
//           handleSave={handleSave}
//           form={form}
//           testimonialsData={pageData?.testimonials}
//           loading={isPending}
//           reviewMode={reviewMode}
//           setReviewMode={setReviewMode}
//           editingReviewIndex={editingReviewIndex}
//           setEditingReviewIndex={setEditingReviewIndex}
//           onDeleteReview={handleReviewDelete}
//         />
//       )}
//       {activeTab === "Footer" && (
//         <Footer
//           isEditing={isEditing}
//           setIsEditing={setIsEditing}
//           handleCancel={handleCancel}
//           handleSave={handleSave}
//           form={form}
//           footerData={pageData?.footer}
//           loading={isPending}
//         />
//       )} 
//     </div>
//   );
// };

// export default HomeTabs;




import React, { useEffect, useState } from "react";
import { useMessageApi } from "../../../provider/AntdNotification";
import { useQueryState } from "nuqs";
import { Form } from "antd";

import TabsContain from "../../components/reuseComp/TabsContain";
import HomeBanner from "./HomeBanner";
import FilingMilestone from "./FilingMilestone";
import QuickActions from "./QuickActions";
import FilingProgress from "./FilingProgress";
import TaxesSimplified from "./TaxesSimplified";
import AboutSection from "./AboutSection";
import Testimonials from "./Testimonials";
import Footer from "./Footer";

import { IPagePayload, PageType } from "../../../types/api/allPages";
import { useAllPageDetail, useAllPageSave } from "../../../hooks/api/allPages/hooks";

const sections: Section = [
  "Banner",
  "Filing Milestones",
  "Quick Actions",
  "Filing Progress",
  "Taxes Simplified",
  "About"
];

export type Section = string[];

interface HomeTabsProps {
  setBreadcrumb: (value: string) => void;
}

const HomeTabs: React.FC<HomeTabsProps> = ({ setBreadcrumb }) => {
  const message = useMessageApi();
  const [tab, setTab] = useQueryState("tab");
  const activeTab = tab || "Banner";
  const [isEditing, setIsEditing] = useState(false);
  const [form] = Form.useForm();

  const [pageData, setPageData] = useState<Record<string, any>>({});
  const [reviewMode, setReviewMode] = useState<"list" | "add" | "edit">("list");
  const [editingReviewIndex, setEditingReviewIndex] = useState<number | null>(null);

  const pageType: PageType = "HOME"; // Adjust per your backend enum

  // ----------------------- Fetch Page -----------------------
  const { data, isFetching } = useAllPageDetail(pageType);

  // ----------------------- Save Page ------------------------
  const { mutate: savePage, isPending:isLoading } = useAllPageSave(pageType, {
    onSuccess: (res) => {
      message.success("Home data updated successfully");
      setPageData(res.data?.data || {});
      setIsEditing(false);
      setReviewMode("list");
      setEditingReviewIndex(null);
    },
    onError: () => message.error("Failed to update page"),
  });

  useEffect(() => {
    if (data?.data) setPageData(data.data?.data);
  }, [data]);

  // ----------------------- Tab Handling ---------------------
  const handleChangeTab = (section: string) => {
    setTab(section);
    setIsEditing(false);
    setBreadcrumb(section);
    setReviewMode("list");
    setEditingReviewIndex(null);
  };

  const handleSave = async () => {
    try {
      const values = await form.validateFields();

      const payload: any = {
        _id: data?.data?._id,
        ...pageData ,
        ...values
      };

    


      savePage(payload);
    } catch (err) {
    }
  };

  const handleCancel = () => {
    setIsEditing(false);
    setReviewMode("list");
    setEditingReviewIndex(null);
  };

  const handleReviewDelete = (index: number) => {
    const updated = [...(pageData?.testimonials?.items || [])];
    updated.splice(index, 1);

    const payload: IPagePayload = {
  _id: data?.data?._id,
  pageType: pageType, // <-- add this
  data: { ...pageData },
};

    savePage(payload);
  };
  // ----------------------- Render --------------------------
  return (
    <div>
      <TabsContain handleChangeTab={handleChangeTab} sections={sections} activeTab={activeTab} />

      {activeTab === "Banner" && (
        <HomeBanner
          isEditing={isEditing}
          setIsEditing={setIsEditing}
          handleCancel={handleCancel}
          handleSave={handleSave}
          form={form}
          bannerData={pageData?.banner}
          loading={isLoading}
        />
      )}

      {activeTab === "Filing Milestones" && (
        <FilingMilestone
          isEditing={isEditing}
          setIsEditing={setIsEditing}
          handleCancel={handleCancel}
          handleSave={handleSave}
          milestoneData={pageData?.milestone}
          form={form}
          loading={isLoading}
        />
      )}

      {activeTab === "Quick Actions" && (
        <QuickActions
          isEditing={isEditing}
          setIsEditing={setIsEditing}
          handleCancel={handleCancel}
          handleSave={handleSave}
          quickActionsData={pageData?.quickActions}
          form={form}
          loading={isLoading}
        />
      )}

      {activeTab === "Filing Progress" && (
        <FilingProgress
          isEditing={isEditing}
          setIsEditing={setIsEditing}
          handleCancel={handleCancel}
          handleSave={handleSave}
          filingProgressData={pageData?.filingProgress}
          form={form}
          loading={isLoading}
        />
      )}

      {activeTab === "Taxes Simplified" && (
        <TaxesSimplified
          isEditing={isEditing}
          setIsEditing={setIsEditing}
          handleCancel={handleCancel}
          handleSave={handleSave}
          taxesSimplifiedData={pageData?.taxesSimplified}
          form={form}
          loading={isLoading}
        />
      )}

      {activeTab === "About" && (
        <AboutSection
          isEditing={isEditing}
          setIsEditing={setIsEditing}
          handleCancel={handleCancel}
          handleSave={handleSave}
          aboutData={pageData?.about}
          form={form}
          loading={isLoading}
        />
      )}

      {/* {activeTab === "Testimonials" && (
        <Testimonials
          isEditing={isEditing}
          setIsEditing={setIsEditing}
          handleCancel={handleCancel}
          handleSave={handleSave}
          form={form}
          testimonialsData={pageData?.testimonials}
          loading={isLoading}
          reviewMode={reviewMode}
          setReviewMode={setReviewMode}
          editingReviewIndex={editingReviewIndex}
          setEditingReviewIndex={setEditingReviewIndex}
          onDeleteReview={handleReviewDelete}
        />
      )}

      {activeTab === "Footer" && (
        <Footer
          isEditing={isEditing}
          setIsEditing={setIsEditing}
          handleCancel={handleCancel}
          handleSave={handleSave}
          form={form}
          footerData={pageData?.footer}
          loading={isLoading}
        />
      )} */}
    </div>
  );
};

export default HomeTabs;









// import React, { useEffect, useState } from "react";
// import { useMessageApi } from "../../../provider/AntdNotification";
// import { useQueryState } from "nuqs";
// import { Form } from "antd";

// import TabsContain from "../../components/reuseComp/TabsContain";
// import HomeBanner from "./HomeBanner";
// import FilingMilestone from "./FilingMilestone";
// import QuickActions from "./QuickActions";
// import FilingProgress from "./FilingProgress";
// import TaxesSimplified from "./TaxesSimplified";
// import AboutSection from "./AboutSection";
// import Testimonials from "./Testimonials";
// import Footer from "./Footer";

// import { IPagePayload, PageType } from "../../../types/api/allPages";
// import {
//   useAllPageDetail,
//   useAllPageSave,
// } from "../../../hooks/api/allPages/hooks";

// const sections: string[] = [
//   "Banner",
//   "Filing Milestones",
//   "Quick Actions",
//   "Filing Progress",
//   "Taxes Simplified",
//   "About",
// ];

// interface HomeTabsProps {
//   setBreadcrumb: (value: string) => void;
// }

// const HomeTabs: React.FC<HomeTabsProps> = ({ setBreadcrumb }) => {
//   const message = useMessageApi();
//   const [tab, setTab] = useQueryState("tab");
//   const activeTab = tab || "Banner";

//   const [isEditing, setIsEditing] = useState(false);
//   const [form] = Form.useForm();

//   const [pageData, setPageData] = useState<Record<string, any>>({});
//   const [reviewMode, setReviewMode] = useState<"list" | "add" | "edit">("list");
//   const [editingReviewIndex, setEditingReviewIndex] = useState<number | null>(
//     null
//   );

//   const pageType: PageType = "HOME";

//   // ----------------------- Fetch Page -----------------------
//   const { data, isFetching } = useAllPageDetail(pageType);

//   // ----------------------- Save Page ------------------------
//   const { mutate: savePage, isPending: isLoading } = useAllPageSave(
//     pageType,
//     {
//       onSuccess: (res) => {
//         message.success("Home data updated successfully");
//         setPageData(res.data); // ✅ flat
//         setIsEditing(false);
//         setReviewMode("list");
//         setEditingReviewIndex(null);
//       },
//       onError: () => message.error("Failed to update page"),
//     }
//   );

//   // ----------------------- Set Data -------------------------
//   useEffect(() => {
//     if (data?.data) {
//       setPageData(data.data); // ✅ flat
//     }
//   }, [data]);

//   // ----------------------- Tab Handling ---------------------
//   const handleChangeTab = (section: string) => {
//     setTab(section);
//     setIsEditing(false);
//     setBreadcrumb(section);
//     setReviewMode("list");
//     setEditingReviewIndex(null);
//   };

//   // ----------------------- Save -----------------------------
//   const handleSave = async () => {
//     try {
//       const values = await form.validateFields();

//       const payload: any = {
//         _id: pageData?._id,
//         pageType,
//         ...pageData,
//       };

//       switch (activeTab) {
//         case "Banner":
//           if (values.banner) {
//             payload.banner = {
//               ...values.banner,
//               image: values.banner.image?.[0] || "",
//             };
//           }
//           break;

//         case "Filing Milestones":
//           if (values.milestone) {
//             payload.filingMilestones = { ...values.milestone };
//           }
//           break;

//         case "Quick Actions":
//           if (values.quickActions) {
//             payload.quickActions = { ...values.quickActions };
//           }
//           break;

//         case "Filing Progress":
//           if (values.filingProgress) {
//             payload.filingProgress = { ...values.filingProgress };
//           }
//           break;

//         case "Taxes Simplified":
//           if (values.taxesSimplified) {
//             payload.taxesSimplified = {
//               ...values.taxesSimplified,
//               image: values.taxesSimplified.image?.[0] || "",
//             };
//           }
//           break;

//         case "About":
//           if (values.about) {
//             payload.about = { ...values.about };
//           }
//           break;

//         case "Testimonials":
//           const items = [...(pageData?.testimonials?.items || [])];

//           if (reviewMode === "add") {
//             items.push(values.review);
//           }

//           if (reviewMode === "edit" && editingReviewIndex !== null) {
//             items[editingReviewIndex] = values.review;
//           }

//           payload.testimonials = {
//             heading:
//               values.testimonials?.heading ||
//               pageData?.testimonials?.heading,
//             subtext:
//               values.testimonials?.subtext ||
//               pageData?.testimonials?.subtext,
//             items,
//           };
//           break;

//         case "Footer":
//           if (values.footer) {
//             payload.footer = { ...values.footer };
//           }
//           break;
//       }

//       savePage(payload);
//     } catch (err) {
//       console.log("❌ Validation failed:", err);
//     }
//   };

//   const handleCancel = () => {
//     setIsEditing(false);
//     setReviewMode("list");
//     setEditingReviewIndex(null);
//   };

//   const handleReviewDelete = (index: number) => {
//     const updated = [...(pageData?.testimonials?.items || [])];
//     updated.splice(index, 1);

//     const payload: any = {
//       _id: pageData?._id,
//       pageType,
//       ...pageData,
//       testimonials: {
//         ...pageData?.testimonials,
//         items: updated,
//       },
//     };

//     savePage(payload);
//   };

//   // ----------------------- Render --------------------------
//   return (
//     <div>
//       <TabsContain
//         handleChangeTab={handleChangeTab}
//         sections={sections}
//         activeTab={activeTab}
//       />

//       {activeTab === "Banner" && (
//         <HomeBanner
//           isEditing={isEditing}
//           setIsEditing={setIsEditing}
//           handleCancel={handleCancel}
//           handleSave={handleSave}
//           form={form}
//           bannerData={pageData?.data?.banner}
//           loading={isLoading}
//         />
//       )}

//       {activeTab === "Filing Milestones" && (
//         <FilingMilestone
//           isEditing={isEditing}
//           setIsEditing={setIsEditing}
//           handleCancel={handleCancel}
//           handleSave={handleSave}
//           milestoneData={pageData?.data?.filingMilestones}
//           form={form}
//           loading={isLoading}
//         />
//       )}

//       {activeTab === "Quick Actions" && (
//         <QuickActions
//           isEditing={isEditing}
//           setIsEditing={setIsEditing}
//           handleCancel={handleCancel}
//           handleSave={handleSave}
//           quickActionsData={pageData?.data?.quickActions}
//           form={form}
//           loading={isLoading}
//         />
//       )}

//       {activeTab === "Filing Progress" && (
//         <FilingProgress
//           isEditing={isEditing}
//           setIsEditing={setIsEditing}
//           handleCancel={handleCancel}
//           handleSave={handleSave}
//           filingProgressData={pageData?.data?.filingProgress}
//           form={form}
//           loading={isLoading}
//         />
//       )}

//       {activeTab === "Taxes Simplified" && (
//         <TaxesSimplified
//           isEditing={isEditing}
//           setIsEditing={setIsEditing}
//           handleCancel={handleCancel}
//           handleSave={handleSave}
//           taxesSimplifiedData={pageData?.data?.taxesSimplified}
//           form={form}
//           loading={isLoading}
//         />
//       )}

//       {activeTab === "About" && (
//         <AboutSection
//           isEditing={isEditing}
//           setIsEditing={setIsEditing}
//           handleCancel={handleCancel}
//           handleSave={handleSave}
//           aboutData={pageData?.data?.about}
//           form={form}
//           loading={isLoading}
//         />
//       )}

//       {/* {activeTab === "Testimonials" && (
//         <Testimonials
//           isEditing={isEditing}
//           setIsEditing={setIsEditing}
//           handleCancel={handleCancel}
//           handleSave={handleSave}
//           form={form}
//           testimonialsData={pageData?.data?.testimonials}
//           loading={isLoading}
//           reviewMode={reviewMode}
//           setReviewMode={setReviewMode}
//           editingReviewIndex={editingReviewIndex}
//           setEditingReviewIndex={setEditingReviewIndex}
//           onDeleteReview={handleReviewDelete}
//         />
//       )}

//       {activeTab === "Footer" && (
//         <Footer
//           isEditing={isEditing}
//           setIsEditing={setIsEditing}
//           handleCancel={handleCancel}
//           handleSave={handleSave}
//           form={form}
//           footerData={pageData?.data?.footer}
//           loading={isLoading}
//         />
//       )} */}
//     </div>
//   );
// };

// export default HomeTabs;